import { Reveal, SectionHeading } from "./Reveal";
import { MoonStar } from "lucide-react";

const phases = [
    {
        n: "01",
        name: "The Pumpkin Hatch",
        items: ["Contract deployment & verification", "Website launch & spectral branding", "Community building on X & Telegram", "Initial meme warfare & pumpkin hype"],
    },
    {
        n: "02",
        name: "The Full Moon Ritual",
        items: ["Raydium DEX launch", "DexScreener & DEXTools trending", "CoinGecko & CoinMarketCap listings", "5,000+ dedicated pumpkin holders"],
    },
    {
        n: "03",
        name: "Haunted Domination",
        items: ["CEX exchange listings", "Spooky meme gallery expansion", "Pupoweenwifhat merch drop & contests", "100,000+ community army & moonshot"],
    },
];

export const Roadmap = () => (
    <section id="roadmap" data-testid="roadmap-section" className="relative z-10 bg-[#151022] py-28">
        <div className="mx-auto max-w-5xl px-5">
            <SectionHeading overline="Phases of the moonshot" title="The Spooky Roadmap" sub="Every full moon, the pack grows stronger" />
            <div className="relative">
                <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-orange-500/60 via-purple-500/40 to-emerald-400/60 md:left-1/2" aria-hidden="true" />
                {phases.map((p, i) => (
                    <Reveal key={p.n} delay={i * 0.15} className="relative mb-14 last:mb-0">
                        <div
                            data-testid={`roadmap-phase-${p.n}`}
                            className={`flex flex-col gap-4 pl-14 md:w-1/2 md:pl-0 ${
                                i % 2 === 0 ? "md:pr-14 md:text-right" : "md:ml-auto md:pl-14"
                            }`}
                        >
                            <div
                                className={`absolute top-1 left-0 flex h-10 w-10 items-center justify-center rounded-full border border-orange-400/50 bg-[#0D0B14] shadow-[0_0_18px_rgba(255,107,0,0.4)] md:top-0 ${
                                    i % 2 === 0 ? "md:left-auto md:-right-5" : "md:-left-5"
                                }`}
                            >
                                <MoonStar size={17} className="text-orange-400" />
                            </div>
                            <p className="font-mono2 text-xs font-bold tracking-[0.3em] text-purple-400">PHASE {p.n}</p>
                            <h3 className="font-spooky text-3xl text-orange-400 text-glow-orange sm:text-4xl">{p.name}</h3>
                            <ul className={`space-y-2 ${i % 2 === 0 ? "md:[direction:rtl]" : ""}`}>
                                {p.items.map((it) => (
                                    <li key={it} className="text-sm text-slate-400 [direction:ltr]">
                                        <span className="mr-2 text-emerald-400">✦</span>
                                        {it}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
